import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";

const OurCommitmentSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#1A1A1A",
        py: { xs: 6, md: 8 },
        px: 4,
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center">
          {/* Left Section - Image and Text */}
          <Grid item xs={12} md={6}>
            {/* Image */}
            <Box
              sx={{
                mb: 4,
                width: "100%",
                maxWidth: "450px",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  borderRadius: "15px",
                  overflow: "hidden",
                }}
              >
                <Box
                  component="img"
                  src={require("assets/images/about4.png")}
                  alt="Trusted Health Partner"
                  sx={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </Box>
            </Box>

            {/* Text below image */}
            <Box
              sx={{
                textAlign: "left",
                width: "100%",
                maxWidth: "450px",
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "1.2rem", md: "1.4rem" },
                  fontWeight: 700,
                  fontFamily: "Outfit",
                  color: "#4ef4ff",
                  mb: 2,
                }}
              >
                Trusted by 500+ Clients
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  fontWeight: 400,
                  fontFamily: "Outfit",
                  color: "#FFFFFF",
                  lineHeight: 1.6,
                }}
              >
                We're proud to be a health partner for individuals who want to
                take control of their wellness journey with confidence.
              </Typography>
            </Box>
          </Grid>

          {/* Right Section - Content and Image */}
          <Grid item xs={12} md={6}>
            {/* Heading */}
            <Box sx={{ width: "100%", maxWidth: "600px" }}>
              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: 600,
                  fontFamily: "Outfit",
                  color: "#4ef4ff",
                  lineHeight: 1.2,
                  mb: 2,
                }}
              >
                Our Commitment Supporting Your Health, Anytime, Anywhere
              </Typography>

              {/* Descriptive Text */}
              <Typography
                sx={{
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  fontWeight: 400,
                  fontFamily: "Outfit",
                  color: "#FFFFFF",
                  lineHeight: 1.6,
                  mb: 4,
                }}
              >
                At Fitify, we believe nutrition and wellness guidance should be
                accessible, personalized, and simple. That's why we're committed
                to bringing expert dietitians and health insights to you no
                matter where you are. We combine science based nutrition with
                modern technology to help you achieve your health goals without
                confusion or restrictions.
              </Typography>
            </Box>

            {/* Bottom Image */}
            <Box
              sx={{
                width: "100%",
                maxWidth: "600px",
                borderRadius: "15px",
                overflow: "hidden",
              }}
            >
              <Box
                component="img"
                src={require("assets/images/about5.png")}
                alt="Expert Nutrition Guidance"
                sx={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default OurCommitmentSection;
